<template>
	<div class="messageCenter">
        <el-tabs v-model="tabName" style="height: 100%;">

          <el-tab-pane label="" name="common">
            <div slot="label" style="padding: 0 2em;">
              公共
            </div>
            <messageList messageType="common"/>
          </el-tab-pane>

          <el-tab-pane label="" name="personal">
            <div slot="label" style="padding: 0 2em;">
              个人
            </div>
            <messageList messageType="personal"/>
          </el-tab-pane>

        </el-tabs>
	</div>
</template>
<script>
import messageList from "./components/messageList";
import infoItem from "@/components/Information/infoItem";
export default {
	name: "message",
	components: {
		infoItem,
		messageList
	},
	data() {
		return {
			tabName: "common",
		}
	},
	computed: {
	},
	mounted() {
	},
	methods: {

	}
}
</script>
<style lang="scss" scpoed>
.messageCenter{
	padding: 0 20px;
	height: 100%;
	.el-tabs__content{
		height: calc(100% - 60px);
	}
	.el-tab-pane{
		height: 100%;
	}
}
.tabContent{
	height: calc(100% - 40px);
	overflow: scroll;
}
.messageBox{
	padding: 10px 20px;
	border-radius: 8px;
	border: 1px solid hsla(0, 0%, 85%, 1);
}
.messageBox+.messageBox{
	margin-top: 10px;
}
</style>